<template>
  <div>
    <div v-if="order">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="order.status"
                      :selectedValue="order.status"
                      :options="statuses"
                      selectLabel="label"
                      selectValue="val"
                      @input="updateProperty($event, 'status')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditText from '@/components/Helpers/Form/EditText'
import axios from 'axios'
import Form from '@/components/Helpers/Modal/Form'

export default {
  data () {
    return {
      order: {},
      statuses: [
        {val: 'New', label: 'New'},
        {val: 'Contacted', label: 'Contacted'},
        {val: 'In progress', label: 'In progress'},
        {val: 'Content sent for publishing', label: 'Content sent for publishing'},
        {val: 'Rejected', label: 'Rejected'},
        {val: 'Completed', label: 'Completed'},
        {val: 'Hold', label: 'Hold'}
      ]
    }
  },
  components: {
    eTxt: EditText,
    eModal: Form
  },
  mounted () {
    this.getOrder()
  },
  methods: {
    async updateProperty (val, prop) {
      let data = {}
      data[prop] = val
      try {
        const res = await axios.patch(`/v2/orders/${this.order.id}`, data)
        this.eUser = res.data
        this.$toastr.success(`${prop} updated successfully`, 'Good')
        this.$forceUpdate()
      } catch (err) {
        this.$toastr.error(err, 'Unable to update')
      }
    },
    async getOrder () {
      try {
        const res = await axios.get(`/v2/orders/${this.$route.params.id}`)
        this.order = res.data
      } catch (err) {
        this.$toastr.error(err, 'Unable to get order')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Order.vue